<!--
    @id        ui-tab-default
    @desc      tab组件
    @level      ui：UI组件
    @author    陈曦源
    @date      2018-10-12 15:48:58
-->

<template>
    <div ref="tabs-container" class="tabs-contianer">
        <div class="tab" v-for="(tab,index) in tabs" :key="index" :class="activeTab ==index ? 'active': 'unactive'" ref="tabs"
            @click="selectTab(index)"><span>{{tab}}</span></div>
        <div class="active-tab-cursor" :style="activeTabCursorStyle"></div>
    </div>
</template>

<script>
export default {
    props: {
        tabs: Array,
        activeTab: {
            type: Number,
            default: 0
        },
        border: {
            type: Boolean,
            default: true
        },
    },
    data(){
        return {
            show: false
        }
    },
    mounted(){
        this.show = true
    },
    computed: {
        activeTabCursorStyle(){
            if (!this.show) return {}
            let activeTab = this.activeTab
            let tabs = this.$refs.tabs
            let tabsContainer = this.$refs["tabs-container"]
            if (!tabs) return {}
            let tab = tabs[activeTab]
            if (!tab) return {}
            if (!this.border) return {}

            let containerRect = tabsContainer.getBoundingClientRect()
            let tabRect = tab.getBoundingClientRect()
            return {
                left: tabRect.left - containerRect.left + "px",
                width: tabRect.width + "px",
                bottom: containerRect.bottom - tabRect.bottom + "px"
            }
        }
    },
    methods: {
        selectTab(index){
            this.$emit("active-tab", index)
        }
    }
}
</script>

<style lang="less" scoped>
@import "~@styles/variable.less";

.tabs-contianer{
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items:center;
    font-size:@font-size-info;
    padding: 15px 20px 0;
    .lg-devices({font-size:@font-size-primary;padding: 15px 20px 0;});
    .md-devices({font-size:@font-size-regular;padding: 15px 20px 0;});
    .tab{
        cursor: pointer;
        margin-right:10px;
        min-width: 10px;
        display: flex;
        align-items: center;
        text-align: center;
        box-sizing: border-box;
        height: 30px;
        .md-devices({margin-right:25px;});
        &:hover{
            border-bottom: 2px @color-main-light solid;
        }
    }
    .active{
        font-weight:bold;
    }
    .unactive{
        font-weight:normal;
    }
    .active-tab-cursor{
        position: absolute;
        background: @color-main;
        height: 2px;
        transition: width .3s, left .3s, bottom .3s;
    }
}
</style>
